// routes for WorkSchedulePrint
import { AppRouteProps } from '~/routes';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';

export default function ResourcesMaterialsRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {
      path: '/material',
      component: Index,
      isProtected: true,
      permissions: ['material_index'],
    },
    {
      path: '/material/create',
      component: Create,
      isProtected: true,
      permissions: ['material_create'],
    },
    {
      path: '/material/edit/:id',
      component: Edit,
      isProtected: true,
      permissions: ['material_edit'],
    },
  ];

  return routes;
}